import React from 'react';
// import { FileExcel } from 'styled-icons/bootstrap';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import dayjs from 'dayjs';

function ExportExcelApplications(props) {
  const { dataGeneral } = props;

  const [data, setData] = React.useState({});

  const exporter = React.useRef();

  const exportExcelFunction = () => {
    if (exporter.current) {
      exporter.current.save();
    }
  };

  React.useEffect(() => {
    const temp = (dataGeneral || []).reduce((acc, element) => {
      const data = { ...element };
      data.dateFormat = dayjs(element.time).format('DD / MMM / YYYY');
      acc.push(data);
      return acc;
    }, []);
    setData(temp);
  }, [dataGeneral]);

  return (
    <>
      <button type="button" className="k-button k-primary" onClick={exportExcelFunction}>
        Exportar a Excel
      </button>
      <ExcelExport data={data} fileName="HistoriaPostulaciones.xlsx" ref={exporter}>
        <ExcelExportColumn title="Nombre" field="names" />
        <ExcelExportColumn title="Apellidos" field="lastNames" />
        <ExcelExportColumn title="Correo electrónico" field="email" />
        <ExcelExportColumn title="Vacante" field="jobName" />
        <ExcelExportColumn title="Fecha" field="dateFormat" />
      </ExcelExport>
    </>
  );
}

export default ExportExcelApplications;
